import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, catchError, map, of, tap } from 'rxjs';
import { CpSetupService } from '../setup/cp-setup.service';
import { CpClientDataEditConfigModel } from '../../helpers/objects/dto/client-data-edit/cp-client-data-edit-model';

@Injectable({
  providedIn: 'root'
})
export class CpClientDataEditService {
  private configSubject = new BehaviorSubject<CpClientDataEditConfigModel>(new CpClientDataEditConfigModel({ canEdit: true }));
  config$ = this.configSubject.asObservable();

  constructor(private cpSetupService: CpSetupService) {}

  get canEdit(): boolean {
    return this.configSubject.value.canEdit;
  }

  load(): Observable<CpClientDataEditConfigModel> {
    return this.cpSetupService.clientDataEdit().pipe(
      map((response) => response?.config ?? new CpClientDataEditConfigModel({ canEdit: true })),
      catchError(() => of(new CpClientDataEditConfigModel({ canEdit: true }))),
      tap((config) => this.configSubject.next(config))
    );
  }
}
